export const getPaginationPages = (
  currentPage: number,
  totalPages: number
): (string | number)[] => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages: (string | number)[] = [1];

  if (currentPage <= 3) {
    pages.push(2, 3);
    if (currentPage === 3) {
      pages.push(4);
    }
    pages.push('...');
    pages.push(totalPages);
  } else if (currentPage === totalPages - 2) {
    pages.push('...');
    pages.push(currentPage - 1, currentPage, currentPage + 1, totalPages);
    return pages;
  } else if (currentPage > totalPages - 2) {
    pages.push('...');
    pages.push(totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push('...');
    pages.push(currentPage - 1, currentPage, currentPage + 1);
    pages.push('...');
    pages.push(totalPages);
  }

  return pages;
};
